import React from 'react';
import PropTypes from 'prop-types';

import Flex from './Flex';
import MenuItemSymbol from './MenuItemSymbol';

const MenuItem = ({
  name,
  price,
  description,
  options,
  isGlutenFree,
  isVegetarian,
  symbolTheme,
}) => (
  <div>
    <Flex container="-ml-4 justify-between" item="pl-4">
      <p className="text-white text-xl">{name}</p>
      <p className="text-white text-xl font-medium">{price}</p>
    </Flex>
    <p className="text-lg leading-relaxed mt-3">
      {description}
      <Flex as="span" itemAs="span" container="inline-flex" item="pl-2">
        {isGlutenFree && <MenuItemSymbol symbol="GF" theme={symbolTheme} />}
        {isVegetarian && <MenuItemSymbol symbol="V" theme={symbolTheme} />}
      </Flex>
    </p>
    {options && (
      <p className="text-lg leading-relaxed text-white mt-4 whitespace-pre-line">{options}</p>
    )}
  </div>
);

MenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.string,
  description: PropTypes.string,
  options: PropTypes.string,
  isGlutenFree: PropTypes.bool,
  isVegetarian: PropTypes.bool,
  symbolTheme: PropTypes.oneOf(['light', 'dark']),
};

MenuItem.defaultProps = {
  price: null,
  description: null,
  options: null,
  isGlutenFree: false,
  isVegetarian: false,
  symbolTheme: 'dark',
};

export default MenuItem;
